export default {
  GENERIC_SAVE_SUCCESS: 'Changes saved successfully.',
  GENERIC_DELETE_RECORD_SUCCESS: 'Record deleted successfully.',
  GENERIC_DELETE_RECORD_FAILURE: 'Unable to delete the record.',
  GENERIC_DELETE_PERMISSION_SUCCESS: 'Permission deleted successfully',
}
